"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UICardHero;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

function UICardHero(_ref) {
  var className = _ref.className,
      children = _ref.children,
      other = (0, _objectWithoutProperties2.default)(_ref, ["className", "children"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, other, {
    className: (0, _classNames.default)('private-card__image--hero', className)
  }), children);
}

UICardHero.propTypes = {
  children: _react.PropTypes.node
};
UICardHero.displayName = 'UICardHero';
module.exports = exports.default;